import tenantTheme from '@theme';
import styled from 'styled-components';

export const HasVerifiedCheck = styled('div')`
  position: relative;

  .icon {
    position: absolute;
    inset-block-end: 0;
    inset-inline-end: 0;
  }

  .icon-check {
    background-color: var(--icon-bg, #fff);
    box-shadow: 0 1px 2px #0002;
    border-radius: 50%;
    color: var(--icon-color, ${tenantTheme['link-color']});

    ${({ applyMediaQueries }) =>
      applyMediaQueries &&
      `
      @media only screen and (min-width: 1400px) and (max-width: 1600px) {
        inset-block-end: -2px;
        inset-inline-end: -17px;
      }
    `}
  }

  /* Golden Pin: applied = soft gold tint + hairline, disabled = neutral grey, hover = lighter gold. */
  ${({ goldVariant, goldApplied, goldDisabled }) =>
    goldVariant &&
    `
    .ant-btn {
      ${goldApplied ? 'background: #fffbea !important; border: 1px solid #f0d98a !important;' : ''}
      ${goldDisabled && !goldApplied ? 'background: #fafafa !important; border-color: transparent !important;' : ''}
      ${goldDisabled && !goldApplied ? 'svg path, svg circle { stroke: #c4c4c4; }' : ''}
      ${
        !goldApplied && !goldDisabled
          ? '&:hover, &:focus { background: #fffcf0 !important; border-color: #f2e3b0 !important; }'
          : ''
      }
    }
    .icon-golden-check {
      inset-block-end: -2px;
      inset-inline-end: -2px;
      width: 17px;
      height: 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffd60a;
      border-radius: 50%;
      box-shadow: 0 0 0 1.5px #fff;
    }
  `}

  .icon-applied {
    --icon-bg: #28b16d;
    --icon-color: #fff;

    inset-block-end: -2px;
    inset-inline-end: -2px;

    ${({ applyMediaQueries }) =>
      applyMediaQueries &&
      `
      @media only screen and (min-width: 1400px) and (max-width: 1600px) {
        inset-block-end: -2px;
        inset-inline-end: -10px;
      }
    `}
  }
`;
